export default class TimesheetsWeekGroupingListItem {
  constructor(params) {
    /**
     * Week range string
     * @type {String}
     */
    this.title = params.title
    /**
     * Date of one of the timesheet for sorting
     * @type {Date}
     */
    this.sortDate = params.sortDate
    /**
     * Dictionary of sub-grouped (by client or candidate name) timesheets
     * @type {Object}
     */
    this.timesheets = params.timesheets
  }
}
